import { storefrontApi } from "@app/lib/storefrontApi"
import { Product, ProductInventory } from "@app/types/product"

const cache = new Map<string, Product>();

export const getProduct = async (handle: string): Promise<Product> => {
  if (cache.has(handle)) {
    return cache.get(handle)!;
  }

  const res = await storefrontApi(
    `
    query productByHandle($handle: String!) {
      productByHandle(handle: $handle) {
        id
        handle
        title
        availableForSale
        tags
        isGiftCard
        priceRange {
          maxVariantPrice {
            currencyCode
            amount
          }
          minVariantPrice {
            currencyCode
            amount
          }
        }
        compareAtPriceRange {
          maxVariantPrice {
            currencyCode
            amount
          }
          minVariantPrice {
            currencyCode
            amount
          }
        }
        variants(first: 100) {
          edges {
            node {
              id
              quantityAvailable
            }
          }
        }
        collections(first: 100) {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  `,
    {
      handle,
    },
  );

  const product = res.productByHandle;

  cache.set(handle, product);

  return product;
};

export const getProductInventoryByStyleColourCode = async (styleCode: string, colourCode: string): Promise<ProductInventory> => {
  const res = await storefrontApi(
    `
    query productInventoryByStyleColourCode($query: String!) {
      products(first: 1, query: $query) {
        nodes {
          id
          handle
          availableForSale
          variants(first: 100) {
            nodes {
              id
              availableForSale
              quantityAvailable
              selectedOptions {
                name
                value
              }
            }
          }
        }
      }
    }
  `,
    {
      query: `tag:'x-styleCode:${styleCode}' tag:'x-colourCode:${colourCode}'`,
    },
  );

  return res.products?.nodes?.[0];
};

export const getCollectionProducts = async (collectionId: string): Promise<Product[]> => {
  const res = await storefrontApi(
    `
    query collectionProducts($collectionId: ID!) {
      collection(id: $collectionId) {
        products(first: 100) {
          edges {
            node {
              id
              handle
              title
              availableForSale
              tags
              isGiftCard
              priceRange {
                maxVariantPrice {
                  currencyCode
                  amount
                }
                minVariantPrice {
                  currencyCode
                  amount
                }
              }
              compareAtPriceRange {
                maxVariantPrice {
                  currencyCode
                  amount
                }
                minVariantPrice {
                  currencyCode
                  amount
                }
              }
              images(first: 100) {
                edges {
                  node {
                    url
                  }
                }
              }
              variants(first: 100) {
                edges {
                  node {
                    id
                    title
                    availableForSale
                    price {
                      currencyCode
                      amount
                    }
                    compareAtPrice {
                      currencyCode
                      amount
                    }
                    selectedOptions {
                      name
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
    {
      collectionId,
    },
  );

  return res.collection.products.edges.map((e: any) => e.node);
};
